import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessManageRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessManageRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 送り先番号を取得するユースケース
 * @param destination - 送り先情報
 */
export class GetSalesDestinationNumberUseCase {
  private repository: IBaseBusinessManageRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessManageRepository) {
    this.repository = repository;
  }
  /**
   * 送り先番号を取得する
   * @param destinationName - 送り先名
   */
  async execute(destinationName: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getSalesDestinationNumber(destinationName);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
